import { defAction } from "../../../../helpers/defaultAction"
import { referenceUnitConstants } from "./constants"
import api from './api'

export const referenceUnitActions = {
	getReferenceUnits,
	clearReferenceUnits
}

function getReferenceUnits(values){
	const dispatchObj = {
		constants : referenceUnitConstants.GetReferenceUnits,
		service   : {
			func   : api.getReferenceUnits,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearReferenceUnits(){
	return (dispatch) => dispatch({	type: referenceUnitConstants.ClearReferenceUnits })
}